"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scheggia-e-pascelupo": {
    "cc33d6a8": [{
      "hkey": "7579f597",
      "slug": "scheggia-e-pascelupo",
      "name": "Scheggia e Pascelupo",
      "primary": true,
      "skipSearch": false
    }],
    "casacce": [{
      "hkey": "7579f597",
      "slug": "scheggia-e-pascelupo",
      "name": "Scheggia e Pascelupo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "393b8ef8": [{
      "hkey": "1f828f2e",
      "slug": "montebollo",
      "name": "Montebollo",
      "primary": true,
      "skipSearch": false
    }],
    "monte-bollo": [{
      "hkey": "1f828f2e",
      "slug": "montebollo",
      "name": "Montebollo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;